import {
    COMMUNITY_LIST_REQUEST,
    COMMUNITY_LIST_SEARCH_REQUEST,
    COMMUNITY_LIST_RESPONSE,
    COMMUNITY_LIST_CACHED_RESPONSE,
    COMMUNITY_LIST_ERROR_RESPONSE,
    COMMUNITY_ITEM_SAVE_REQUEST,
    COMMUNITY_ITEM_SAVE_RESPONSE,
    COMMUNITY_ITEM_REQUEST,
    COMMUNITY_ITEM_RESPONSE,
    COMMUNITY_ITEM_CACHED_RESPONSE,
    COMMUNITY_ITEM_ERROR_RESPONSE,
    COMMUNITY_SET_FILTER,
    COMMUNITY_UPDATE_FILTER_CRITERIA,
    COMMUNITY_CLEAR_FILTER_CRITERIA,
    COMMUNITY_APPLY_FILTER_CRITERIA,
    COMMUNITY_UPDATE_IMAGE,
    COMMUNITY_UPDATE_MODEL,
    COMMUNITY_APPLY_MODEL_UPDATE,
    COMMUNITY_CANCEL_MODEL_UPDATE,
    COMMUNITY_SET_EDIT_MODE,
    COMMUNITY_CANCEL_ADDING_MEMBERS,
    COMMUNITY_APPLY_ADD_SELECTED_MEMBERS,
    COMMUNITY_SELECT_ADD_MEMBER,
    COMMUNITY_SELECT_REMOVE_PARTICIPANT,
    COMMUNITY_PROMOTE_MEMBER,
    COMMUNITY_ADD_NEW
} from "./action-types"

import {
    defaultAction,
    itemRequest,
    setFilter,
    setEditMode,
    updateFilterCriteria,
    clearFilterCriteria,
    applyFilterCriteria,
    updateImage,
    updateModel,
    applyModelUpdate,
    cancelModelUpdate,
    listSearchRequest
} from "./default-actions/presentation-actions"
import {
    itemResponse,
    itemSaveRequest,
    itemCachedResponse,
    itemErrorResponse
} from "./default-actions/entity-actions"
import {
    listRequest,
    listInvalidationRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"

// Paging Actions
export const communityListRequest = listRequest(COMMUNITY_LIST_REQUEST)
export const communityListInvalidationRequest = listInvalidationRequest(
    COMMUNITY_LIST_REQUEST
)
export const communityListSearchRequest = listSearchRequest(
    COMMUNITY_LIST_SEARCH_REQUEST
)
export const communityListResponse = listResponse(COMMUNITY_LIST_RESPONSE)
export const communityListCachedResponse = listCachedResponse(
    COMMUNITY_LIST_CACHED_RESPONSE
)
export const communityListErrorResponse = listErrorResponse(
    COMMUNITY_LIST_ERROR_RESPONSE
)

// Entity Actions
export const communityItemRequest = itemRequest(COMMUNITY_ITEM_REQUEST)
export const communityItemResponse = itemResponse(COMMUNITY_ITEM_RESPONSE)
export const communityItemCachedResponse = itemCachedResponse(
    COMMUNITY_ITEM_CACHED_RESPONSE
)
export const communityItemErrorResponse = itemErrorResponse(
    COMMUNITY_ITEM_ERROR_RESPONSE
)
export const communityItemSaveRequest = itemSaveRequest(
    COMMUNITY_ITEM_SAVE_REQUEST
)
export const communityItemSaveResponse = itemResponse(
    COMMUNITY_ITEM_SAVE_RESPONSE
)

// Presentation Actions
export const communitySetFilter = setFilter(COMMUNITY_SET_FILTER)
export const communitySetEditMode = setEditMode(COMMUNITY_SET_EDIT_MODE)
export const communityUpdateFilterCriteria = updateFilterCriteria(
    COMMUNITY_UPDATE_FILTER_CRITERIA
)
export const communityClearFilterCriteria = clearFilterCriteria(
    COMMUNITY_CLEAR_FILTER_CRITERIA
)
export const communityApplyFilterCriteria = applyFilterCriteria(
    COMMUNITY_APPLY_FILTER_CRITERIA
)
export const communityUpdateModel = updateModel(COMMUNITY_UPDATE_MODEL)
export const communityUpdateImage = updateImage(COMMUNITY_UPDATE_IMAGE)
export const communityApplyModelUpdate = applyModelUpdate(
    COMMUNITY_APPLY_MODEL_UPDATE
)
export const communityCancelModelUpdate = cancelModelUpdate(
    COMMUNITY_CANCEL_MODEL_UPDATE
)
export const communityCancelAddingMembers = defaultAction(
    COMMUNITY_CANCEL_ADDING_MEMBERS
)
export const communityApplyAddSelectedMembers = defaultAction(
    COMMUNITY_APPLY_ADD_SELECTED_MEMBERS
)
export const communitySelectRemoveParticipant = (participant, type) => ({
    type: COMMUNITY_SELECT_REMOVE_PARTICIPANT,
    participant,
    participantType: type
})
export const communitySelectAddMember = (member, shouldAdd = true) => ({
    type: COMMUNITY_SELECT_ADD_MEMBER,
    member: {
        ...(member || {}),
        isAdded: shouldAdd
    }
})
export const communityPromoteMember = (member, communityId) => ({
    type: COMMUNITY_PROMOTE_MEMBER,
    member,
    communityId
})
export const communityAddNew = defaultAction(COMMUNITY_ADD_NEW)
